export default __webpack_public_path__ + "d7b3a9a83e29340b46f4f08058af7469.svg";